import { render } from "./pdf.vue?vue&type=template&id=4bbfed37&scoped=true"
import script from "./pdf.vue?vue&type=script&lang=js"
export * from "./pdf.vue?vue&type=script&lang=js"

import "./pdf.vue?vue&type=style&index=0&id=4bbfed37&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ydsk-ph-h5-bankv3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bbfed37"]])

export default __exports__